<template>
  <div
    class="news-card"
    :id="id"
    :class="{ highlighted: isHighlighted }"
    ref="card"
    :style="cardStyle"
  >
    <div class="news-card-media" v-if="image_url || video_url">
      <img v-if="image_url" :src="image_url" alt="image">
      <video playsinline muted controls="true" preload="auto" v-if="video_url && !videoYoutube">
        <source :src="video_url" type="video/mp4" />
      </video>
      <iframe v-if="video_url && videoYoutube" :height="dataIframeHeight" :src="video_url" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    </div>
    <div class="news-card-main">
      <div :class="{'news-card-title': true, 'mb-0': date && !dateHidden}" ref="title" v-html="title"></div>
      <div class="news-card-date" v-if="date && !dateHidden"> {{transformDate(date)}} </div>
      <div
        v-if="text"
        class="news-card-details"
        ref="container"
        :class="[
          {
            expand: isExpand,
            single: singleLine,
            double: doubleLine,
            triple: tripleLine,
            'zero-height': image_url || video_url 
          }
        ]"
        :style="[isExpand ? { height: child + 'px' } : {}]"
      >
        <div
          class="news-card-details-text"
          ref="details"
          v-html="text"
        ></div>
      </div>
      <div
        v-if="!isDisabled"
        class="news-card-trigger"
        :class="[{ expand: isExpand }]"
        @click="onExpand"
      ><b-icon icon="chevron-down"></b-icon></div>
    </div>
  </div>
</template>
<script>
import lineClamp from "line-clamp";

const pxIndex = (string) => string.indexOf('px')

const setLink = (link) => {
  link.addEventListener("click", (event) => {
    event.preventDefault();
    const href = link.getAttribute("href");
    if (href.charAt(0) === "/") {
      if (href.includes("downloads/")) {
        window.open(href, "_blank");
      } else {
        this.$router.push(href);
      }
    } else {
      window.open(href, "_blank");
    }
  });
}

const getStyleOptionValue = (element, option) => {
  const elementOptionString = getComputedStyle(element)[option]
  const elementOption = +elementOptionString.substring(0, pxIndex(elementOptionString))
  return elementOption
}

export default {
  name: "news-card",
  props: {
    id: String,
    title: String,
    text: String,
    highlighted: Boolean,
    listener: Boolean,
    expanded: Boolean,
    active: Boolean,
    date: String,
    featured: Boolean,
    image_url: String,
    ribbon_colour: String,
    video_url: String,
    dateHidden: Boolean,
    update: Boolean
  },
  data() {
    return {
      isExpand: false,
      isDisabled: false,
      isHighlighted: false,
      detailsText: "",
      details: null,
      parrentNew: 0,
      dataText: "",
      parrent: 0,
      child: 0,
      titleHeight: 0,
      titleLineHeight: 0,
      textLineHeight: 0,
      elem: null,
      singleLine: false,
      doubleLine: false,
      tripleLine: false,
      dataIframeHeight: 0
    };
  },
  computed: {
    videoYoutube() {
      return  this.video_url && this.video_url.includes('https://www.youtube.com');
    },
    cardStyle() {
      const style = {
        borderTopColor: '#715BFF',
        borderTopWidth: '4px',
        borderTopStyle: 'solid'
      }
      if (!this.isDisabled) {
        style.paddingBottom ='50px'
      }
      return style
    }
  },
  watch: {
    highlighted() {
      this.isHighlighted = this.highlighted;
    },
    update() {
      this.details.innerHTML = this.dataText;
      this.setVars();
      this.setCard();
    }
  },
  methods: {
    onExpand() {
      if (this.isDisabled) {
        return
      }
      if (this.isExpand) {
       this.processCollapse()
       return
      }
      this.processExpand()
    },
    processExpand() {
      this.details.innerHTML = this.dataText;
      const links = this.details.querySelectorAll("a");
      links.forEach(link => {
        setLink(link)
      })
      this.isExpand = true;
      this.$emit("expand", this);
      setTimeout(() => {
        this.$refs.card.scrollIntoView({
          block: "start",
          behavior: "smooth"
        });
      }, 200);
    },
    processCollapse() {
      if (this.titleHeight == this.titleLineHeight * 3) {
        setTimeout(() => {
          lineClamp(this.details, 6);
        }, 400);
      }
      if (this.titleHeight == this.titleLineHeight * 2) {
        setTimeout(() => {
          lineClamp(this.details, 7);
        }, 400);
      } 
      if (this.titleHeight == this.titleLineHeight) {
        setTimeout(() => {
          lineClamp(this.details, 8);
        }, 400);
      } 
      this.isExpand = false
      this.$emit("collapse")
    },
    setVars() {
      if (!this.text) {
        return
      }
      const titleHeightString = getComputedStyle(this.$refs["title"]).height
      const titleLineHeightString = getComputedStyle(this.$refs["title"]).lineHeight
      const textLineHeightString = getComputedStyle(this.$refs["details"]).lineHeight

      this.titleHeight = +titleHeightString.substring(0, pxIndex(titleHeightString))
      this.titleLineHeight = +titleLineHeightString.substring(0, pxIndex(titleLineHeightString))
      this.dataTextLineHeight = +textLineHeightString.substring(0, pxIndex(textLineHeightString))

      if (this.titleHeight === this.titleLineHeight) {
        this.singleLine = true;
      } 
      if (this.titleHeight === this.titleLineHeight * 3) {
        this.tripleLine = true;
      } 
      if (this.titleHeight === this.titleLineHeight * 2) {
        this.doubleLine = true;
      }
    },
    setCard() {
      if (!this.text) {
        return
      }
      const parrentHeightString = getComputedStyle(this.$refs["container"]).height
      const childHeightString = getComputedStyle(this.$refs["details"]).height
      this.parrent = +parrentHeightString.substring(0, pxIndex(parrentHeightString))
      this.child = +childHeightString.substring(0, pxIndex(childHeightString))
      if (this.parrent > this.child) {
        this.isDisabled = true;
        return
      }
      if (this.titleHeight === this.titleLineHeight) {
        lineClamp(this.details, 8);
      } 
      if (this.titleHeight == this.titleLineHeight * 2) {
        lineClamp(this.details, 7);
      }
      if (this.titleHeight == this.titleLineHeight * 3) {
        lineClamp(this.details, 6);
      }
    },
    transformDate(date) {
      return this.$date(new Date(date), 'd MMM, yyyy');
    },
    iframeHeight() {
      const iframeWidth = getStyleOptionValue(this.$refs["card"] ,'width')
      const iframeHeight = iframeWidth /16 * 9
      this.dataIframeHeight = iframeHeight
    }
  },
  mounted() {
    this.$nextTick(async function() {
      this.details = this.$refs["details"]
      this.dataText = this.text
      this.isHighlighted = this.highlighted;
      this.setVars();
      this.setCard();
      this.iframeHeight();
      if (!this.text) {
        this.isDisabled = true
      }
      if ((this.image_url || this.video_url) && this.text) {
        this.isDisabled = false
      }
      if (this.isHighlighted && !this.isDisabled) {
        this.processExpand();
      }
      if (this.$route.params.tab && this.$route.params.tab === this.id) {
        this.processExpand()
        const routeParam = this.$route.params.tab
        this.elem = document.querySelector(`#${routeParam}`)
        this.elem.scrollIntoView({ block: "start", behavior: "smooth" })
      }
      this.$emit("cardMounted", this);
    });
  }
};
</script>
<style lang="scss">
.news-card {
  max-width: 535px;
  min-height: 330px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  background-color: #fff;
  box-shadow: 0px 5px 9px rgba(190, 190, 190, 0.5);
  position: relative;
  margin-bottom: 20px;

  &-media {
    width: 100%;
    height: auto;

    video, img {
      width: 100%;
      height: auto;
    }

    iframe {
      width: 100%;
    }
  }

  &-main {
    padding:  15px;
  }

  &-title {
    font-weight: 600;
    font-size: 20px;
    line-height: 30px;
    color: #333333;
    margin-bottom: 12px;
  }

  &-date {
    font-weight: 300;
    font-size: 14px;
    line-height: 21px;
    margin-top: 8px;
    margin-bottom: 16px;
  }

  &-details {
    height: 168px;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    color: #333333;
    overflow: hidden;
    transition: 0.4s ease;
    &.single {
      height: 192px;

       &.zero-height {
        height: 0;
      }
    }
    &.double {
      height: 168px;

       &.zero-height {
        height: 0;
      }
    }
    &.triple {
      height: 144px;

       &.zero-height {
        height: 0;
      }
    }
    
    &.zero-height {
      height: 0;
    }
    p {
      &:first-child {
        margin-top: 0;
      }
      a {
        color: #005EB8;
        &:hover {
          color: #005EB8;
          text-decoration: underline;
        }
      }
    }

    &-title {
      margin: 20px 0;
      font-size: 14px;
      line-height: 21px;
      font-weight: 600;
    }

    &-text {
      ul {
        list-style: circle;
        padding-left: 20px;
        li {
          margin-bottom: 10px;
        }
      }
    }

    &-list {
      p {
        padding-bottom: 8px;
        margin-bottom: 8px;
        margin-top: 0;
        border-bottom: 1px solid #e3eaee;
        display: flex;
        justify-content: space-between;
      }
    }

    ul {
      list-style: circle;
      padding-left: 20px;
      li {
        margin-bottom: 10px;
      }
    }
  }

  &-trigger {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 22px;
    height: 22px;
    border: 1px solid #005EB8;
    color: #005EB8;
    font-size: 12px;
    border-radius: 50%;
    background-color: #fff;
    position: absolute;
    bottom: 16px;
    left: 50%;
    margin-left: -11px;
    transform-origin: center;
    transition: 0.2s linear;
    cursor: pointer;
    &.expand {
      background-color: #005EB8;
      color: #fff;
      transform-origin: center;
      transform: rotate(-180deg);
      transition: 0.2s linear;
    }
    &.disabled {
      display: none;
    }
  }
  &.highlighted {
    outline: 2px solid #005EB8;
  }
}
</style>
